import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { MessageService } from '../../../shared/message.service';
import { catchError, throwError } from 'rxjs';
import { SHOW_TOAST } from '../../../login/login.service';
import { Router } from '@angular/router';
import { AccountService } from '../../../login/account.service';


export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  const messageService = inject(MessageService);
  const router = inject(Router);
  const accountService = inject(AccountService);

  return next(req).pipe(
    catchError((error) => {
      let msg = 'Ocurrió un error, por favor inténtelo nuevamente';
      const showToast = req.context.get(SHOW_TOAST);

      if (error?.error?.message) {
        msg = error.error.message;
      } else {
        switch (error.status) {
          case 400:
            msg = 'Solicitud incorrecta';
            break;
          case 401:
            if (req.url.includes('/auth/login')) {
              msg = 'Error al iniciar sesión. Por favor, revise su correo electrónico e intente nuevamente';
            } else {
              accountService.logout();
            }
            break;
          case 403:
            msg = 'Acceso denegado';
            break;
          case 404:
            msg = 'Recurso no encontrado';
            break;
          case 406:
            msg = 'Inaceptable';
            break;
          case 409:
            msg = 'El correo electrónico ya está registrado';
            break;
          case 500:
            msg = 'Error interno del servidor';
            break;
        }
      }

      if (showToast && (error.status !== 401 || showToast)) {
        messageService.showError(msg);
      }

      return throwError(() => error);
    })
  );
};
